import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { FaInstagram, FaApple } from "react-icons/fa";
import LogoIcon from "components/brand/LogoIcon";
import { REOPEN_EVENT } from "components/CookieConsent";
import { SITE_TAX_YEAR } from "data/tax-calendar-years";

const APP_STORE_URL = "https://apps.apple.com/app/id6768791934";

const PublicLayout = ({ children, title, description }: { children: React.ReactNode; title?: string; description?: string }) => {
  const location = useLocation();
  const token = localStorage.getItem("mt_token");

  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    // #anchor varsa (ör. eski /sss/<soru> -> /blog/<yazi>#<soru> 301'i) oraya, yoksa basa
    const target = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) target.scrollIntoView(); else window.scrollTo(0, 0);
  }, [title, description, location]);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-40 border-b border-gray-100 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
          <Link to="/" className="flex items-center gap-2">
            <LogoIcon size={36} />
            <span className="font-outfit text-xl font-extrabold tracking-tight text-brand-500">MALİ AJANDA</span>
          </Link>
          <nav className="hidden items-center gap-6 md:flex">
            <Link to="/" className="text-sm font-medium text-gray-600 hover:text-brand-500">Anasayfa</Link>
            <Link to="/vergi-takvimi" className="text-sm font-medium text-gray-600 hover:text-brand-500">Vergi Takvimi</Link>
            <Link to="/mevzuat-haberleri" className="text-sm font-medium text-gray-600 hover:text-brand-500">Mevzuat</Link>
            <Link to="/ozellikler" className="text-sm font-medium text-gray-600 hover:text-brand-500">Özellikler</Link>
            <Link to="/mobil-uygulama" className="inline-flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-brand-500">
              <FaApple className="h-4 w-4" /> Mobil
            </Link>
            <Link to="/blog" className="text-sm font-medium text-gray-600 hover:text-brand-500">Blog</Link>
            <Link to="/sss" className="text-sm font-medium text-gray-600 hover:text-brand-500">SSS</Link>
            <Link to="/iletisim" className="text-sm font-medium text-gray-600 hover:text-brand-500">İletişim</Link>
          </nav>
          <div className="flex items-center gap-2">
            {token ? (
              <Link to="/admin/default" className="rounded-xl bg-brand-500 px-5 py-2 text-sm font-medium text-white hover:bg-brand-600">Panele Git</Link>
            ) : (
              <>
                <Link to="/auth/sign-in" className="rounded-xl border border-gray-200 px-3 py-2 text-xs font-medium text-gray-700 hover:border-brand-500 hover:text-brand-500 sm:px-5 sm:text-sm">Giriş Yap</Link>
                <Link to="/auth/sign-in" className="rounded-xl bg-brand-500 px-3 py-2 text-xs font-medium text-white hover:bg-brand-600 sm:px-5 sm:text-sm">Ücretsiz Başla</Link>
              </>
            )}
          </div>
        </div>
      </header>

      {/* Content */}
      <main>{children}</main>

      {/* Footer */}
      <footer className="mt-20 border-t border-gray-100 bg-gray-50">
        <div className="mx-auto max-w-6xl px-4 py-12">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
            <div className="col-span-2">
              <div className="flex items-center gap-2">
                <LogoIcon size={36} />
                <span className="font-outfit text-xl font-extrabold tracking-tight text-brand-500">MALİ AJANDA</span>
              </div>
              <p className="mt-1 ml-1 text-xs uppercase tracking-[0.2em] text-gray-500">Mali Müşavirin Dijital Ajandası</p>
              <p className="mt-3 text-sm text-gray-600">Mali müşavirler ve SMMM'ler için {SITE_TAX_YEAR} vergi takvimi, cari hesap takibi ve hesaplama araçları içeren profesyonel mali yönetim uygulaması.</p>

              {/* App Store badge */}
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-flex items-center gap-3 rounded-lg bg-black px-4 py-2 text-white shadow-md transition hover:bg-gray-900"
                aria-label="App Store'dan İndir"
              >
                <FaApple className="h-7 w-7" />
                <div className="flex flex-col leading-tight">
                  <span className="text-[9px] font-medium opacity-80">Şuradan İndirin:</span>
                  <span className="text-base font-semibold">App Store</span>
                </div>
              </a>
              <p className="mt-2 text-xs text-gray-500">Android sürümü yakında</p>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-bold text-navy-700">Ürün</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><Link to="/vergi-takvimi" className="hover:text-brand-500">{SITE_TAX_YEAR} Vergi Takvimi</Link></li>
                <li><Link to="/ozellikler" className="hover:text-brand-500">Özellikler</Link></li>
                <li><Link to="/mobil-uygulama" className="hover:text-brand-500">Mobil Uygulama</Link></li>
                <li><Link to="/blog" className="hover:text-brand-500">Blog</Link></li>
                <li><Link to="/sss" className="hover:text-brand-500">SSS</Link></li>
                <li><Link to="/auth/sign-in" className="hover:text-brand-500">Ücretsiz Dene</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-bold text-navy-700">Popüler Rehberler</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><Link to="/blog/2026-vergi-takvimi" className="hover:text-brand-500">2026 Vergi Takvimi</Link></li>
                <li><Link to="/blog/kdv-beyannamesi" className="hover:text-brand-500">KDV Beyannamesi</Link></li>
                <li><Link to="/blog/mali-takvim-nedir" className="hover:text-brand-500">Mali Takvim Nedir?</Link></li>
                <li><Link to="/blog/muhtasar-beyanname" className="hover:text-brand-500">Muhtasar Beyanname</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-bold text-navy-700">İletişim</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><a href="mailto:info@maliajanda.com" className="hover:text-brand-500">info@maliajanda.com</a><div className="text-xs text-gray-400">Genel sorular</div></li>
                <li><a href="mailto:destek@maliajanda.com" className="hover:text-brand-500">destek@maliajanda.com</a><div className="text-xs text-gray-400">Teknik destek</div></li>
                <li><Link to="/iletisim" className="hover:text-brand-500">İletişim Formu</Link></li>
                <li>
                  <a
                    href="https://www.instagram.com/maliajanda_/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 hover:text-brand-500"
                  >
                    <FaInstagram className="h-4 w-4" />
                    <span>Instagram: @maliajanda_</span>
                  </a>
                  <div className="text-xs text-gray-400">Sosyal Medya</div>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 border-t border-gray-200 pt-6 text-center text-xs text-gray-500">
            © 2026 Mali Ajanda - Tüm hakları saklıdır. | <Link to="/iletisim" className="hover:text-brand-500">İletişim</Link> | <Link to="/gizlilik" className="hover:text-brand-500">Gizlilik & KVKK</Link> | <Link to="/kullanim-sartlari" className="hover:text-brand-500">Kullanım Şartları</Link> |{" "}
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event(REOPEN_EVENT))}
              className="underline-offset-2 hover:text-brand-500 hover:underline"
            >
              Çerez tercihleri
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
